import { render, staticRenderFns } from "./DriverAttribute.vue?vue&type=template&id=d2b9b11e&"
import script from "./DriverAttribute.vue?vue&type=script&lang=js&"
export * from "./DriverAttribute.vue?vue&type=script&lang=js&"
import style0 from "./DriverAttribute.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports